import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ktostamm-lieferant-detail-view',
  imports: [],
  templateUrl: './ktostamm-lieferant.detail-view.html',
  styleUrls: ['./ktostamm-lieferant.detail-view.css'],
})
export class KtostammLieferantDetailView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
